import React from 'react';
import './App.css';
import Navigation from './Components/Navigation/Navigation';
import Home from './Components/Home/Home';
import Footer from './Components/Footer/Footer';
import BubbleCursor from './Components/BubbleCursor/BubbleCursor';

function App() {
  return (
    <div className="App">
      <Navigation />
      <Home />
      <Footer />
      <BubbleCursor />
    </div>
  );
}

export default App;
